// Alta de un equipo en la lista de participantes del torneo.
//
// Al agregarlo se le precarga la lista de fe con los jugadores que lo tienen asignado
// en el padrón. Lo usan el alta manual (TeamsScreen) y la importación de la estructura
// desde Excel, que agrega varios equipos de una.
export function nuevoEquipoDeTorneo(option, jugadores = []) {
  const nombre = String(option.label || "").trim();
  const players = jugadores
    .filter((j) => (j.equipo || "").toUpperCase() === nombre.toUpperCase())
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((j) => ({
      id: j.value,
      _id: j.value,
      value: j.value,
      label: j.label,
      name: j.label,
      camiseta: j.camiseta,
      isExcepcion: !!j.isExcepcion,
    }));

  return { _id: option.value, id: option.value, name: nombre, players };
}
